import pdfWorkerUrl from 'modules/common/components/PDFRenderer/pdfWorker?worker&url';

export async function isPdfPasswordProtected(blob: Blob): Promise<boolean> {
    const { pdfjs } = await import('react-pdf');
    if (!pdfjs.GlobalWorkerOptions.workerSrc) {
        pdfjs.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;
    }
    const data = await blob.arrayBuffer();
    try {
        const loadingTask = pdfjs.getDocument({ data });
        const doc = await loadingTask.promise;
        await doc.destroy();
        return false;
    } catch (err) {
        if (err && typeof err === 'object' && 'name' in err && (err as { name: string }).name === 'PasswordException') {
            return true;
        }
        throw err;
    }
}
